export enum GuestNotesForms {
  Remove = 'RemoveGuestNotes',
  Update = 'UpdateGuestNote',
  Create = 'CreateGuestNote',
}
